import { gql } from "@apollo/client";
import useStdQuery from "components/data/hooks/useStdQuery.js";

const GET_REPLACEMENT_OPTIONS = gql`
	query replacementOptionsGET (
		$subsystemAccountReference: ID!
		$tokenId: String!
		$replacementType: String!
	) {
		TransitAccountRoute {
			getReplacementOptions (
				subsystemAccountReference: $subsystemAccountReference
				tokenId: $tokenId
				replacementType: $replacementType
			) {
				id
				mediaProducts {
					id
					mediaSKU
					mediaTypeId
					mediaTypeName
					mediaGroupId
					mediaName
					mediaShortName
					mediaLongName
					mediaFee
					mediaDepositFee
					mediaReplacementFee
					mediaEnablementFee
					riderClassId
					riderClassDescription
					subsystemTokenType
					inventoryPartNumber
					waiveEnableFeeFlag
					isNegativeBalanceTravelAllowed
					writeOffClose
					enablementFeeType
					isNonReloadable
					waiveEnableFeeReasonCode
					mediaRestrictions {
						mediaRestrictionId
						mediaRestrictionName
					}
					display {
						order
						group
					}
				}
			}
		}
	}
`;

export const useReplacementOptions = ({
	/**
	 * @type string(20)
	 * (Required) Unique identifier for the transit account.
	 * */
	subsystemAccountReference,
	tokenId,
	replacementType,

	queryOptions,
}) => {

	const queryResult = useStdQuery(GET_REPLACEMENT_OPTIONS, {
		variables: {
			subsystemAccountReference,
			tokenId,
			replacementType,
		},
		...queryOptions,
		skip: !tokenId,
	});

	const {
		mediaProducts,
	} = queryResult?.data?.TransitAccountRoute.getReplacementOptions ?? {};

	return {
		mediaProducts,
		queryResult,
	};
};
